import Table from '@/components/Table/Table.jsx'
import TableChooseComponent from '../_COMPONENT/TableChooseComponent.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {useTableColumnBdName, useTableColumnBdNo} from '../BD/useTableColumnBd.jsx'
import RuleType from '../BDRULE/RuleType.jsx'

const dictRuleType = Object.fromEntries(RuleType.map(([k, v]) => [k, v]))

const TableChooseBdrule = (props) => {
    const map = useMapContext()

    const columns = [
        'BCT' === map.data.prjTypeCode && {
            title: '界面方案',
            dataIndex: 'uiCase',
            component: <Table.ViewText />,
        },

        useTableColumnBdName(),
        useTableColumnBdNo(),

        {
            title: '规则标题',
            dataIndex: 'ruleTitle',
            component: <Table.ViewText />,
        },

        {
            title: '规则类型',
            dataIndex: 'ruleType',
            component: <Table.ViewDict dict={dictRuleType} />,
        },
    ].filter(a => a)

    return (
        <TableChooseComponent
            columns={columns}
            {...props}
        />
    )
}

export default TableChooseBdrule
